function getInvestigativeHistory (http, id) {
    return http.get('/InvestigativeHistory/Get?investigativeHistoryId=' + id)
}

function putInvestigativeHistory (http, dto) {
    return http.put('/InvestigativeHistory/', dto)
}

function searchInvestigativeHistory (http, searchDto) {
    return http.post('/InvestigativeHistory/Search', searchDto)
}

//Discovery Methods
function getDiscoveryMethod (http, id) {
    return http.get('/DiscoveryMethod/Get?discoveryMethodId' + id)
}

function putDiscoveryMethod (http, dto) {
    return http.put('/DiscoveryMethod/', dto)
}

function searchDiscoveryMethod (http, searchDto) {
    return http.post('/DiscoveryMethod/Search', searchDto)
}

//Investigative Work Instances
function getInvestigativeWork (http, id) {
    return http.get('/InvestigativeWork/Get?investigativeWorkInstanceId' + id)
}

function putInvestigativeWork (http, dto) {
    return http.put('/InvestigativeWork/', dto)
}

function searchInvestigativeWork (http, searchDto) {
    return http.post('/InvestigativeWork/Search', searchDto)
}

function getDiscoveryMethodList () {
    return [
        {discoveryMethodId: 1, description: 'Exposed on surface'},
        {discoveryMethodId: 2, description: 'Exposed subsurface'},
        {discoveryMethodId: 3, description: 'Construction discovery'},
        {discoveryMethodId: 4, description: 'Documentary sources'},
        {discoveryMethodId: 5, description: 'Informant'}
    ]
}

function getInvestigativeWorkTypeList () {
    return [
        {investigativeWorkTypeId: 1, description: 'Surface recorded'},
        {investigativeWorkTypeId: 2, description: 'Shovel tested'},
        {investigativeWorkTypeId: 3, description: 'Formal test unit(s)'},
        {investigativeWorkTypeId: 4, description: 'Block excavation'},
        {investigativeWorkTypeId: 5, description: 'Tested with probe device'},
        {investigativeWorkTypeId: 6, description: 'Controlled Trench/Blade'},
        {investigativeWorkTypeId: 7, description: 'Geomorphology study'},
        {investigativeWorkTypeId: 8, description: 'Paleo-environmental study'},
        {investigativeWorkTypeId: 9, description: 'Materials sourcing'},
        {investigativeWorkTypeId: 10, description: 'Remote sensing'},
        {investigativeWorkTypeId: 11, description: 'Photos/Sketches/Video'},
        {investigativeWorkTypeId: 12, description: 'Collections research'},
        {investigativeWorkTypeId: 13, description: 'Lab analyses'},
        {investigativeWorkTypeId: 14, description: 'Material sample program'},
        {investigativeWorkTypeId: 15, description: 'C-14 dating'},
        {investigativeWorkTypeId: 16, description: 'Other'}
    ]
}

export default {
    getDiscoveryMethodList: getDiscoveryMethodList,
    getInvestigativeWorkTypeList: getInvestigativeWorkTypeList,

    getInvestigativeHistory: getInvestigativeHistory,
    putInvestigativeHistory: putInvestigativeHistory,
    searchInvestigativeHistory: searchInvestigativeHistory,

    getInvestigativeWork: getInvestigativeWork,
    putInvestigativeWork: putInvestigativeWork,
    searchInvestigativeWork: searchInvestigativeWork,

    getDiscoveryMethod: getDiscoveryMethod,
    putDiscoveryMethod: putDiscoveryMethod,
    searchDiscoveryMethod: searchDiscoveryMethod
}



// WEBPACK FOOTER //
// ./src/services/siteForm/investigativeHistoryService.js